import { render, staticRenderFns } from "./KnTextArea.vue?vue&type=template&id=19a5d190&"
import script from "./KnTextArea.vue?vue&type=script&lang=js&"
export * from "./KnTextArea.vue?vue&type=script&lang=js&"
import style0 from "./KnTextArea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports